(function () {
    try {
        var nativeFetch = window.fetch;
        var isUpdatingCart = false;

        window.fetch = function (...args) {
            try {
                if (typeof args[0] === 'string' && (args[0].includes("/cart/change") || args[0].includes("/cart/add") || args[0].includes("/cart/update"))) {
                    $("#corner-cowi-cart-summary-card-cta-button").addClass("opacity-50");  
                  $("#corner-cowi-cart-summary-card-cta-button").attr("disabled", true);
                  if (!isUpdatingCart) {
                        isUpdatingCart = true;
                        setTimeout(async function () {
                            await setDateTimeInCart();
                           $("#corner-cowi-cart-summary-card-cta-button").removeClass("opacity-50");  
                          $("#corner-cowi-cart-summary-card-cta-button").attr("disabled", false);
                            isUpdatingCart = false;
                        }, 800);
                    }
                }
            } catch (err) {
                // console.error("Error in intercepting fetch:", err);
            }
            return nativeFetch.apply(window, args);
        }
    } catch (e) {
        // console.error("Error in overriding fetch:", e);
    }

    async function setDateTimeInCart() {
        try {
            const response = await fetch('/cart/update.js', {
                method: "POST",
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    attributes: {
                        Discountly_dateTime: globalFields.Storetime()
                    }
                })
            });

            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`);
            }

            const data = await response.json();
            // console.log('Cart updated successfully:', data);
        } catch (error) {
            // console.error('Failed to update cart:', error);
        }
    }

    // Add event listener for page load to update the cart attribute
    window.addEventListener('load', async () => {
        await setDateTimeInCart();
    });
})();
  // checkout click
  jQuery(document).on('click','#corner-cowi-cart-summary-card-cta-button',function(e){
     e.preventDefault();
    //GetCode(true);
  })
  

    async function GetCode(isUpper) {
      
let cartTotal = await fetchAndLogCartTotal()/100;
 let ShippingDiscountCode = '';   
if (globalFields.isCustomer) {
    const isCruCustomer = globalFields.CustomerTagCheck;  // is_cru_customer should be a boolean or value in your JS context
    if (isCruCustomer && cartTotal > 50) {
        ShippingDiscountCode = 'CRUFREESHIPPING';
    } else if (!isCruCustomer && cartTotal > 250) {
        ShippingDiscountCode = 'NONCRUFREESHIPPING';
    }
} else {
    if (cartTotal > 250) {
        ShippingDiscountCode = 'NONCRUFREESHIPPING';
    }
}

      let DiscountCode1 = "CRUFREESHIPPING,NONCRUFREESHIPPING";
      DiscountCodeCookie(DiscountCode1);
      jQuery('form[action="/cart"]').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode1 + '">');
      window.location.href = '/checkout?discount=' +DiscountCode1;
   }

    var DiscountCodeCookie = function (discount_code) {
       jQuery.ajax({
           type: "HEAD", url: "/discount/" + discount_code,
           success: function (_result) { },
           error: function (e) { console.log(e.statusText); }
       })
   }

// Define your fetchCartTotal function as before
async function fetchAndLogCartTotal() {
    try {
        const cartTotal = await fetchCartTotal();
        return cartTotal;
    } catch (error) {
        console.error('Error fetching cart total:', error);
        throw error; // Rethrow the error to be caught by the caller
    }
}

// Define your fetchCartTotal function as before
async function fetchCartTotal() {
    try {
        const response = await fetch('/cart.js');
        const data = await response.json();
        return data.original_total_price;
    } catch (error) {
        console.error('Error fetching cart total:', error);
        throw error; // Rethrow the error to be caught by fetchAndLogCartTotal
    }
}
   var SetCookie = function (cname, cvalue, exdays) { var d = new Date(); d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000)); var expires = "expires=" + d.toUTCString(); document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; }